import useValidate from '@/shared/lib/validate'
import { useConfig } from '@/features/Inventory/ObjectFileLoader/config'
import { ref } from 'vue'
import { useNotification } from '@/shared/ui'
import { useHelpers, useImageCompressor, useTranslate } from '@/shared/lib'

export const useModel = () => {
  const uploadedFiles = ref<File[]>([])
  const { fileTypes, fileSize } = useValidate()
  const { photoLimit, fileLimit, openAddress } = useConfig()
  const { addError } = useNotification()
  const { trs } = useTranslate()
  const { saveFile } = useHelpers()

  /**
   * Правила проверки файлов
   */
  const rules = {
    files: [
      (value: any[]) =>
        fileTypes(value, [
          'image/png',
          'image/jpeg',
          'image/heic',
          'text/plain',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/zip',
          'application/vnd.rar',
          'application/x-7z-compressed',
        ]),
      (value: any[]) => fileSize(value, photoLimit, fileLimit),
    ],
  }

  const isCompressing = ref(false)

  /**
   * Функция сжатия изображений в списке фалов
   * @param files
   */
  const compressImages = async (files: File[]) => {
    isCompressing.value = true
    const result: File[] = []

    for (let i = 0; i < files.length; i++) {
      const item = files[i]

      if (item.type.startsWith('image/')) {
        try {
          const file = await useImageCompressor.compressImage(item, 1920)
          result.push(file)
        } catch (e: any) {
          addError(trs('itf.compress_error', { name: item.name }))
        }
      } else {
        result.push(item)
      }
    }

    isCompressing.value = false
    return result
  }

  /**
   * Функция определения принадлежности к изображению по расширению
   * @param ext
   */
  const isExtImage = (ext: string) => {
    return ['jpeg', 'jpg', 'png', 'hiec'].includes(ext.toLowerCase())
  }

  /**
   * Функция открытия файла в новой вкладке
   * @param name
   */
  const openHandler = (name: string) => {
    window.open(openAddress + name, '_blank', 'noopener,noreferrer')
  }

  /**
   * Функция скачивания файла
   * @param name
   */
  const downloadHandler = async (name: string) => {
    try {
      const res = await fetch(openAddress + name)
      if (!res.ok) throw new Error(String(res.status))

      const blob = await res.blob()
      const objectUrl = window.URL.createObjectURL(blob)
      saveFile(objectUrl, name)
      window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60_000)
    } catch {
      addError(trs('request.unknown_error'))
    }
  }

  return {
    uploadedFiles,
    rules,
    photoLimit,
    fileLimit,
    isCompressing,

    compressImages,
    isExtImage,
    openHandler,
    downloadHandler,
  }
}
